import { UploadItem } from './uploadItem';

export interface UploadsState {
  items: Record<string, UploadItem>;
}

export const UPLOADS_INITIAL_STATE: UploadsState = {
  items: {},
};
